import { autoinject } from "aurelia-dependency-injection";
import {computedFrom} from "aurelia-framework";
import {type VesselComparisonEnvironmentDetails} from "../../../../../models/vessel-comparison/vessel-comparison.models";

@autoinject()
export class VesselComparisonEnvironmentVm {
    private _vesselComparisonEnvironmentDetails: VesselComparisonEnvironmentDetails;
    safetyScore: number;
    isSanctioned: boolean;
    isFlagFake: boolean;

    @computedFrom("_vesselComparisonEnvironmentDetails")
    get vesselComparisonEnvironmentDetails(): VesselComparisonEnvironmentDetails {
        return this._vesselComparisonEnvironmentDetails;
    }

    set vesselComparisonEnvironmentDetails(value: VesselComparisonEnvironmentDetails) {
        this._vesselComparisonEnvironmentDetails = value;
    }

    @computedFrom("safetyScore", "_vesselComparisonEnvironmentDetails.ghgEmissionsRating")
    get ghgEmissionsRating() {
        let result = "U";

        if(this.safetyScore != 0) {
            result = this._vesselComparisonEnvironmentDetails.ghgEmissionsRating;
        }
        
        return result;
    }
    
    constructor(vesselEnvironmentDetails: VesselComparisonEnvironmentDetails, safetyScore: number, isSanctioned: boolean, isFlagFake: boolean) {
        this.vesselComparisonEnvironmentDetails = vesselEnvironmentDetails;
        this.safetyScore = safetyScore;
        this.isSanctioned = isSanctioned;
        this.isFlagFake = isFlagFake;
    }
}